if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector('.product-images') ? this.productWrapper.querySelector('.product-images') : this.productWrapper.querySelector('.product-quick-images');
        this.thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }

      this.addEventListener('mousedown', (e) => {
        if (e.target.tagName === 'LABEL') {
          const scrollY = window.scrollY;
          requestAnimationFrame(() => window.scrollTo({ top: scrollY, behavior: 'instant' }));
        }
      });
    }

    	// SoundDrop Customisation Start

	bindPreorderListeners() {
	  // prevent double-binding
	  if (this._preorderBound) return;
	  this._preorderBound = true;
	
	  // Ensure fieldsets are current
	  this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
	
	  // Listen to <select> changes
	  this.fieldsets.forEach((fs) => {
	    const sel = fs.querySelector('select');
	    if (sel) {
	      sel.addEventListener('change', () => this.applyPreorderFromAttrs());
	    }
	    // Listen to radio changes
	    fs.querySelectorAll('input[type="radio"]').forEach((inp) => {
	      inp.addEventListener('change', () => this.applyPreorderFromAttrs());
	    });
	    // Also pick up label clicks (after the radio gets checked)
	    fs.querySelectorAll('label[for]').forEach((lab) => {
	      lab.addEventListener('click', () => {
	        requestAnimationFrame(() => this.applyPreorderFromAttrs());
	      });
	    });
	  });
	}
	
	applyPreorderFromAttrs() {
	  const sectionId = this.dataset.section;
	  if (!sectionId) return;
	  // --- read selected attrs from THIS variant-selects
	  let sd = null, av = null, sdlmt = null, sdr = null;
	  this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
	  this.fieldsets.forEach((fs) => {
	    const sel = fs.querySelector('select');
	    if (sel) {
	      const opt = sel.options[sel.selectedIndex];
	      if (opt) {
	        if (opt.hasAttribute('sdlistonwebsiteid')) sd = opt.getAttribute('sdlistonwebsiteid');
	        if (opt.hasAttribute('sdproductavailable')) av = opt.getAttribute('sdproductavailable');
	        if (opt.hasAttribute('sdcustomersalelimit')) sdlmt = opt.getAttribute('sdcustomersalelimit');
          if (opt.hasAttribute('sdreleasedate')) sdr = opt.getAttribute('sdreleasedate');
	      }
	    } else {
	      const checked = fs.querySelector('input[type="radio"]:checked');
	      if (checked) {
	        const lab = fs.querySelector(`label[for="${checked.id}"]`);
	        if (lab) {
	          if (lab.hasAttribute('sdlistonwebsiteid')) sd = lab.getAttribute('sdlistonwebsiteid');
	          if (lab.hasAttribute('sdproductavailable')) av = lab.getAttribute('sdproductavailable');
	          if (lab.hasAttribute('sdcustomersalelimit')) sdlmt = lab.getAttribute('sdcustomersalelimit');
            if (lab.hasAttribute('sdreleasedate')) sdr = lab.getAttribute('sdreleasedate');
	        }
	      }
	    }
	  });
	
	  // Preorder / do-not-sell (existing logic)
	  const isSoldOutByAttr = String(av) === 'false';
	  const isPre       = Number(sd) === 4 && String(av) === 'true';
	  const isDoNotSell = Number(sd) === 3 && String(av) === 'true';

    // Build the "Preorder Group" label, e.g. "Week 14 2026"
    let preorderGroupValue = '';
    if (isPre && sdr) {
      const d = new Date(sdr); // sdr should be "YYYY-MM-DD"
      if (!isNaN(d.getTime()) && typeof getISOWeek === 'function') {
        const year = d.getUTCFullYear();
        const week = getISOWeek(d);
        // Force week 1–9 to be 01–09
        const weekStr = String(week).padStart(2, '0');
        preorderGroupValue = `Week ${weekStr} ${year}`;
      }
    }
	
	  const soldText = (window.theme?.variantStrings?.soldOut)  || 'Sold Out';
	  const preText = (window.theme?.variantStrings?.preOrder)   || 'Pre-order';
	  const addText = (window.theme?.variantStrings?.addToCart)  || 'Add to cart';
	
	  const updateFormBlock = (pfRoot) => {
	    if (!pfRoot) return;
	
	    // Hard sold out via custom attribute
	    if (isSoldOutByAttr) {
	      pfRoot.classList.remove('do-not-show-cart'); // make sure it’s visible but disabled
	      pfRoot.removeAttribute('template');
	
	      pfRoot.querySelectorAll('.single-add-to-cart-button').forEach((btn) => {
	        btn.dataset.hardSoldout = '1';         // <-- add this flag
	        btn.classList.add('hard-soldout');     // optional helper class
	        btn.setAttribute('disabled', 'disabled');
	        btn.classList.add('sold-out');
	        const textEl = btn.querySelector('.single-add-to-cart-button--text');
	        if (textEl) textEl.textContent = soldText;
	      });
	      return; // do not fall through into preorder/add-to-cart logic
	    }
	    // NOT hard-sold-out anymore -> CLEAR the lock flags BEFORE doing anything else
	    pfRoot.querySelectorAll('.single-add-to-cart-button').forEach((btn) => {
	      delete btn.dataset.hardSoldout;         // <— add these lines
	      btn.classList.remove('hard-soldout');   // <— add these lines
	    });
	    // Do-not-sell and Pre-order handling
	    pfRoot.classList.toggle('do-not-show-cart', isDoNotSell);
	
	    if (!isDoNotSell && isPre) {
	      pfRoot.setAttribute('template', 'pre-order');
	    } else if (pfRoot.getAttribute('template')) {
	      pfRoot.removeAttribute('template');
	    }
	    if (!isDoNotSell) {
	      pfRoot.querySelectorAll('.single-add-to-cart-button').forEach((btn) => {
	        const textEl = btn.querySelector('.single-add-to-cart-button--text');
	        if (!textEl) return;
	        // don't touch real sold-out buttons
	        if (btn.hasAttribute('disabled') && btn.classList.contains('sold-out')) return;
	
	        btn.removeAttribute('disabled');
	        btn.classList.remove('sold-out');
	        textEl.textContent = isPre ? preText : addText;
	      });
	    }
	  };
	  // --- main product form
	  const productForm = document.getElementById(`product-form-${sectionId}`);
	  if (productForm) {
	    updateFormBlock(productForm.closest('.product-form'));
	  }
	  // --- sticky product form (if present)
	  const stickyPF = document.querySelector(
	    `product-add-to-cart-sticky[data-section="${sectionId}"] .product-form`
	  );
	  if (stickyPF) {
	    updateFormBlock(stickyPF);
	  }
	  // apply quantity max from sdcustomersalelimit
	  const limit = sdlmt && !isNaN(parseFloat(sdlmt)) ? parseFloat(sdlmt) : null;
	  this.setQtyMaxForSection(sectionId, limit);

	  // Debounced /cart.js refresh for this section
    scheduleLimitRefresh(sectionId);

    // Synchronise the selected variant's release date as a line-item property.
    let releaseDateValue = '';
    if (isPre && sdr) {
      const match = String(sdr).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (match) {
        const day = Number(match[3]);
        const suffix = (day % 100 >= 11 && day % 100 <= 13) ? 'th' :
          (day % 10 === 1 ? 'st' : day % 10 === 2 ? 'nd' : day % 10 === 3 ? 'rd' : 'th');
        const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, day));
        if (!isNaN(date.getTime()) && date.getUTCDate() === day && date.getUTCMonth() === Number(match[2]) - 1) {
          releaseDateValue = `${day}${suffix} ${date.toLocaleString('en-GB', { month: 'long', timeZone: 'UTC' })} ${match[1]}`;
        }
      }
    }
    updateReleaseDatePropertyForSection(sectionId, releaseDateValue);

    // Keep Preorder Group line-item property in sync
    if (typeof updatePreorderGroupPropertyForSection === 'function') {
      updatePreorderGroupPropertyForSection(sectionId, preorderGroupValue);
    }
	}
	
	setQtyMaxForSection(sectionId, limit) {
	  const clamp = (input, lim) => {
	    if (!input) return;
	    if (lim && lim > 0) {
	      input.setAttribute('max', String(lim));
	      const cur = parseFloat(input.value || '1');
	      if (!isNaN(cur) && cur > lim) input.value = String(lim);
	    } else {
	      // no limit -> remove any previous max
	      input.removeAttribute('max');
	    }
	  };
	  // main product form
	  const productForm = document.getElementById(`product-form-${sectionId}`);
	  if (productForm) {
	    clamp(productForm.querySelector('input[name="quantity"]'), limit);
	  }
	}
	// SoundDrop Customisation End
    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.prefetchProductUrls();
      // SoundDrop Customisation Start
      this.bindPreorderListeners();
      this.applyPreorderFromAttrs();
      // SoundDrop Customisation End
    }

    onVariantChange() {
      this.updateOptions();
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();
      this.updateVariantText();
      // SoundDrop Customisation Start
      this.applyPreorderFromAttrs();
	  // SoundDrop Customisation End
      this.renderVariantInfo();

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        variantTitle: this.options.join(' / '),
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      const span = this.querySelector(`#SelectedVariant-${this.dataset.section}`);
      if (!span) return;
      this.currentVariant = {
        id: parseInt(span.dataset.variantId, 10) || null,
        available: span.dataset.available === 'true',
        featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
      };
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(mediaId);

      if (this.thumbnails) {
        this.setActiveMediaSlider(mediaId, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider);
      } else {
        this.setActiveMedia(activeMedia);
      }

    }
    setActiveMedia(activeMedia) {

      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      if (!this.sticky) {
        // Scroll the gallery container to the start so the new active media is
        // visible. The window's scroll position is preserved by the surrounding
        // renderVariantInfo() flow — do not scroll the window here.
        window.setTimeout(() => {
          activeMedia.parentElement.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        });
      }
    }
    setActiveMediaSlider(mediaId, thumbId, productSlider) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (this.thumbnails) {
          let activeThumb = this.thumbnails.querySelector(thumbId);

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');
      if (!pickUpAvailability) return;
      pickUpAvailability.update(this.currentVariant);
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    getSelectedValueIds() {
      return this.fieldsets.map((fieldset) => {
        if (fieldset.querySelector('select')) {
          return fieldset.querySelector('select').selectedOptions[0]?.dataset.valueId;
        }
        return fieldset.querySelector('input:checked')?.dataset.valueId;
      }).filter(Boolean);
    }

    prefetchProductUrls() {
      if (!this.prefetchCache) {
        this.prefetchCache = new Map();
      }
      var self = this;
      var sectionId = this.dataset.section;
      var currentUrl = this.dataset.url;

      this.querySelectorAll('[data-product-url]').forEach(function(el) {
        var productUrl = el.dataset.productUrl;
        if (!productUrl || productUrl === currentUrl) return;

        var target = el.closest('fieldset');
        if (!target) return;

        // For selects, attach to the select element; for radios, attach to the label
        var hoverTarget = el.tagName === 'OPTION' ? el.closest('select') : el.nextElementSibling;
        if (!hoverTarget) hoverTarget = target;

        hoverTarget.addEventListener('mouseenter', function() {
          if (self.prefetchCache.has(productUrl)) return;
          fetch(productUrl + '?section_id=' + sectionId)
            .then(function(response) { return response.text(); })
            .then(function(text) {
              self.prefetchCache.set(productUrl, text);
            })
            .catch(function() {});
        }, { once: true });
      });
    }

    getProductUrl() {
      var currentUrl = this.dataset.url;
      for (var i = 0; i < this.fieldsets.length; i++) {
        var fieldset = this.fieldsets[i];
        var productUrl = null;
        var select = fieldset.querySelector('select');
        if (select) {
          var selected = select.selectedOptions[0];
          if (selected) {
            productUrl = selected.dataset.productUrl;
          }
        } else {
          var checked = fieldset.querySelector('input:checked');
          if (checked) {
            productUrl = checked.dataset.productUrl;
          }
        }
        if (productUrl && productUrl !== currentUrl) {
          return productUrl;
        }
      }
      return null;
    }

    switchProduct(productUrl) {
      var sectionId = this.dataset.section;
      var self = this;

      var handleResponse = function(responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var newSection = html.getElementById('shopify-section-' + sectionId);
        var currentSection = document.getElementById('shopify-section-' + sectionId);

        if (newSection && currentSection) {
          currentSection.innerHTML = newSection.innerHTML;
        }
        window.history.replaceState({}, '', productUrl);
      };

      if (this.prefetchCache && this.prefetchCache.has(productUrl)) {
        handleResponse(this.prefetchCache.get(productUrl));
        return;
      }

      fetch(productUrl + '?section_id=' + sectionId)
        .then(function(response) { return response.text(); })
        .then(handleResponse);
    }

    renderVariantInfo() {
      const ids = this.getSelectedValueIds();
      if (!ids.length) return;

      // Combined listings: check if selected option points to a different product
      const productUrl = this.getProductUrl();
      if (productUrl) {
        this.switchProduct(productUrl);
        return;
      }

      const scrollY = window.scrollY;

      fetch(`${this.dataset.url}?option_values=${ids.join(',')}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          // 1. Resolve variant from hidden span
          const span = html.getElementById(`SelectedVariant-${this.dataset.section}`);
          if (span && parseInt(span.dataset.variantId, 10)) {
            this.currentVariant = {
              id: parseInt(span.dataset.variantId, 10),
              available: span.dataset.available === 'true',
              featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
            };
          } else {
            this.currentVariant = null;
          }

          // Combined listings server-side fallback: check if response is for a different product
          if (span && span.dataset.productUrl && span.dataset.productUrl !== this.dataset.url) {
            this.switchProduct(span.dataset.productUrl);
            return;
          }

          // 2. Sync data-available onto current DOM inputs (drives setDisabled)
          const sourceSelects = html.getElementById(`variant-selects-${this.dataset.section}`);
          if (sourceSelects) {
            sourceSelects.querySelectorAll('[data-value-id]').forEach((sourceEl) => {
              const vid = sourceEl.dataset.valueId;
              const avail = sourceEl.dataset.available;
              [this, ...this.other].forEach((el) => {
                const localEl = el.querySelector(`[data-value-id="${vid}"]`);
                if (localEl) localEl.dataset.available = avail;
              });
            });
          }

          // 3. Update price, inventory, sku sections
          this.getSectionsToRender().forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
            if (id.includes('price') && destination) destination.classList.remove('visibility-hidden');
          });

          // 4. Apply updated state
          if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
            window.scrollTo({ top: scrollY, behavior: 'instant' });
            return;
          }
          this.setDisabled();
          this.updateVariantInput();
          if (this.updateUrl) this.updateURL();
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
          this.updateMedia();
          this.updatePickupAvailability();

          // shopify:product:select — variant resolved for the new option choice
          publishStandardEvent('ProductSelectEvent', {
            product: this.dataset.productId ? { id: this.dataset.productId } : undefined,
            promise: Promise.resolve({ variant: { id: this.currentVariant.id } })
          }, this);

          window.scrollTo({ top: scrollY, behavior: 'instant' });
          // SoundDrop Customisation Start
          this.applyPreorderFromAttrs();
          // SoundDrop Customisation End
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        // SoundDrop Customisation Start
        if (submitButton.dataset.hardSoldout === '1' || submitButton.classList.contains('hard-soldout')) {
          return;
        }
        // SoundDrop Customisation End
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') return;

      this.fieldsets.forEach((fieldset) => {
        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option').forEach((opt) => {
            opt.disabled = opt.dataset.available === 'false';
          });
        } else {
          fieldset.querySelectorAll('input').forEach((input) => {
            input.classList.toggle('is-disabled', input.dataset.available === 'false');
          });
        }
      });
      return true;
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }

    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      const optionPosition = parseInt(this.imageSetIndex.replace('option', ''), 10) - 1;
      const fieldset = this.fieldsets[optionPosition];
      if (!fieldset) return;
      const select = fieldset.querySelector('select');
      const checked = fieldset.querySelector('input:checked');
      let setValue;
      if (select && select.selectedOptions[0]) {
        setValue = select.selectedOptions[0].dataset.handle;
      } else if (checked) {
        setValue = checked.dataset.handle;
      }
      if (!setValue) return;
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this));
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();

      document.addEventListener('product:variant-change', (e) => {
        if (e.detail && e.detail.variantTitle && e.detail.variantTitle !== 'Default Title') {
          this.dataset.variantTitle = e.detail.variantTitle;
          this.updatePswpProductInfo();
        }
      });
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          thumbSrc: activelink.dataset.thumbSrc || activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    buildPswpThumbnails(items) {
      const container = this.pswpElement.querySelector('.pswp__thumbs-inner');
      if (!container) return;
      container.innerHTML = '';
      if (this.dataset.lightboxThumbnails === 'false' || items.length <= 1) {
        container.parentElement.style.display = 'none';
        return;
      }
      container.parentElement.style.display = '';
      items.forEach((item, index) => {
        const thumb = document.createElement('div');
        thumb.className = 'pswp__thumb';
        thumb.dataset.index = index;
        const img = document.createElement('img');
        img.src = item.thumbSrc;
        img.alt = '';
        img.loading = 'lazy';
        thumb.appendChild(img);
        container.appendChild(thumb);
      });
    }
    updatePswpProductInfo() {
      const infoEl = this.pswpElement.querySelector('.pswp__product-info');
      if (!infoEl) return;
      if (this.dataset.lightboxProductInfo === 'false') {
        infoEl.style.display = 'none';
        return;
      }
      infoEl.style.display = '';
      const titleEl = infoEl.querySelector('.pswp__product-title');
      const variantEl = infoEl.querySelector('.pswp__variant-title');
      if (titleEl) titleEl.textContent = this.dataset.productTitle || '';
      if (variantEl) variantEl.textContent = this.dataset.variantTitle || '';
    }
    syncPswpThumbnails(index) {
      const container = this.pswpElement.querySelector('.pswp__thumbs-inner');
      if (!container) return;
      const thumbs = container.querySelectorAll('.pswp__thumb');
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
      });
      const activeThumb = container.querySelector('.pswp__thumb.is-active');
      if (activeThumb) {
        activeThumb.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
      }
    }
    setEventListeners() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0);
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: true,
        allowPanToNext: true,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true
      };

      const _this = this;

      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => _this.zoomClick(e, clone));
      });

      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
    }
    zoomClick(e, link) {
      let items = this.buildItems(this.activeImages);
      let parent = link.closest('.product-images__slide');
      let i = this.activeImages.indexOf(parent);
      this.pswpOptions.index = parseInt(i, 10);
      this.pswpOptions.getThumbBoundsFn = () => {
        const thumbnail = link.closest('.product-single__media'),
          pageYScroll = window.scrollY || document.documentElement.scrollTop,
          rect = thumbnail.getBoundingClientRect();
        return {
          x: rect.left,
          y: rect.top + pageYScroll,
          w: rect.width
        };
      };
      if (typeof PhotoSwipe !== 'undefined') {
        this.buildPswpThumbnails(items);
        this.updatePswpProductInfo();

        const bottomBar = this.pswpElement.querySelector('.pswp__bottom-bar');
        if (bottomBar) {
          ['mousedown', 'touchstart', 'pointerdown'].forEach(evtName => {
            bottomBar.addEventListener(evtName, (evt) => evt.stopPropagation());
          });
        }

        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, items, this.pswpOptions);
        const _this = this;

        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 140
            };
          });
        });

        const scrollWrap = this.pswpElement.querySelector('.pswp__scroll-wrap');
        const resetScroll = function() {
          if (scrollWrap) scrollWrap.scrollLeft = 0;
          _this.pswpElement.scrollLeft = 0;
        };

        pswp.listen('beforeChange', function () {
          const index = pswp.getCurrentIndex();
          _this.syncPswpThumbnails(index);
          resetScroll();
        });

        const thumbsInner = this.pswpElement.querySelector('.pswp__thumbs-inner');
        if (thumbsInner) {
          thumbsInner.addEventListener('click', function handler(evt) {
            evt.stopPropagation();
            const thumb = evt.target.closest('.pswp__thumb');
            if (thumb) {
              pswp.goTo(parseInt(thumb.dataset.index, 10));
              resetScroll();
            }
          });
        }

        pswp.listen('close', function () {
          const container = _this.pswpElement.querySelector('.pswp__thumbs-inner');
          if (container) container.innerHTML = '';
        });

        pswp.init();
        this.syncPswpThumbnails(this.pswpOptions.index);
      }
      e.preventDefault();
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
	// SoundDrop Customisation Start
    async onSubmitHandler(evt) {
    // SoundDrop Customisation End
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
	  // SoundDrop Customisation Start
      // sdcustomersalelimit guard (prevents adds beyond remaining allowance
      try {
        const sectionId = this.dataset.section;
        const limit = getSaleLimitFromActiveAttrsBySection(this.dataset.section);
        if (limit && limit > 0) {
          const variantId = this.form.querySelector('input[name="id"]')?.value;
          const qtyInput  = this.form.querySelector('input[name="quantity"]');
          const requested = parseFloat(qtyInput?.value || '1') || 1;

          if (variantId) {
            const existing = await getCartQtyForVariant(variantId); // fetches /cart.js and totals this variant
            const allowed  = Math.max(0, limit - existing);

            if (allowed <= 0) {
              // Block the add entirely, surface a friendly message, and reflect UI state
              this.handleErrorMessage(`Limit reached: max ${limit} per order for this item.`);
              setPdpQtyMaxAndState(sectionId, 0);
              return;
            }

            if (requested > allowed) {
              // Clamp the outgoing request to what’s left
              qtyInput.value = String(allowed);
            }
          }
        }
      } catch (e) {
        // Fail open—don’t block the user if cart fetch fails
        console.warn('sdcustomersalelimit guard error', e);
      }
      // END: sdcustomersalelimit guard
      // SoundDrop Customisation End
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
      	// SoundDrop Customisation Start
        if (submitButton.dataset.hardSoldout === '1' || submitButton.classList.contains('hard-soldout')) return;
		// SoundDrop Customisation End
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          // SoundDrop Customisation Start
          refreshPdpLimitAgainstCartForSection(this.dataset.section);
		  // SoundDrop Customisation Start
		  
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      }));



      const productDrawer = document.getElementById('Product-Drawer');
      const cartDrawer = document.getElementById('Cart-Drawer');

      if (productDrawer && productDrawer.contains(this)) {
        OverlayManager.close(productDrawer);
        if (cartDrawer) {
          OverlayManager.open(cartDrawer);
          dispatchCustomEvent('cart-drawer:open');
        }
      } else if (cartDrawer) {
        OverlayManager.open(cartDrawer);
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }


    }
    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      this._observer = observer;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
  // SoundDrop Customisation Start
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('variant-selects').forEach((vs) => {
      if (typeof vs.applyPreorderFromAttrs === 'function') {
        // run once in case this instance was connected before buttons existed
        vs.applyPreorderFromAttrs();
      }
    });
  });

  // --- Cart mutation listeners (quantity +/- and remove) -> re-apply button state
  (function bindCartMutationListenersOnce() {
    console.log("bindCartMutationListenersOnce before return");
    if (window.__cartMutationBound) return;
    window.__cartMutationBound = true;

      // Helper to reapply for all product sections currently on the page
      const reapplyAllSections = () => {
        document.querySelectorAll('variant-selects[data-section]').forEach(vs => {
          // only debounce a limit refresh per section; do not immediately re-render
          scheduleLimitRefresh(vs.dataset.section, 500);
        });
      };

      // Delegate clicks on qty +/- and remove
      document.addEventListener('click', (e) => {
        const hit = e.target.closest(
          '.product-cart-item-info quantity-selector button, ' +
          '.product-cart-item-info .remove'
        );
        if (hit) reapplyAllSections();
      });

      // If quantity can be typed directly, catch that too
      document.addEventListener('change', (e) => {
        const hit = e.target.closest(
          '.product-cart-item-info quantity-selector input[type="number"]'
        );
        if (hit) reapplyAllSections();
      });

      // Theme events that imply a cart refresh
      document.documentElement.addEventListener('cart:refresh', reapplyAllSections);
      document.documentElement.addEventListener('cart:item-added', reapplyAllSections);
      document.documentElement.addEventListener('cart-drawer:open', reapplyAllSections);

  })();
  // SoundDrop Customisation End
}

// SoundDrop Customisation Start
function getISOWeek(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
}
async function getCartJSON() {
  const res = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
  if (!res.ok) throw new Error('cart fetch failed');
  return res.json();
}
async function getCartQtyForVariant(variantId) {
  const cart = await getCartJSON();
  return cart.items
    .filter(li => String(li.id) === String(variantId))
    .reduce((sum, li) => sum + (li.quantity || 0), 0);
}
// Debounce limit-refresh calls per section so we don't hammer /cart.js
function scheduleLimitRefresh(sectionId, delay = 500) {
  const timers = (window.__limitTimers = window.__limitTimers || new Map());
  if (timers.has(sectionId)) clearTimeout(timers.get(sectionId));
  timers.set(sectionId, setTimeout(async () => {
    await refreshPdpLimitAgainstCartForSection(sectionId);
    // once limit+qty inputs are correct, (re)apply text and pre-order/ATC state
    const vs = document.querySelector(`variant-selects[data-section="${sectionId}"]`);
    if (vs && typeof vs.applyPreorderFromAttrs === 'function') {
      vs.applyPreorderFromAttrs();
    }
  }, delay));
}
function getCurrentVariantIdFromSection(sectionId) {
  const form = document.getElementById(`product-form-${sectionId}`);
  const idInput = form?.querySelector('input[name="id"]');
  return idInput?.value || null;
}
function getSaleLimitFromActiveAttrsBySection(sectionId) {
  // Scope to the active variant-selects for this section
  const vs = document.querySelector(`variant-selects[data-section="${sectionId}"]`);
  if (!vs) return null;
  // Case A: dropdown
  const sel = vs.querySelector('fieldset select');
  if (sel && sel.selectedIndex >= 0) {
    const opt = sel.options[sel.selectedIndex];
    const v = opt?.getAttribute('sdcustomersalelimit');
    const n = v != null ? parseFloat(v) : NaN;
    return isNaN(n) ? null : n;
  }
  // Case B: radios
  const checked = vs.querySelector('input[type="radio"]:checked');
  if (checked) {
    const lab = vs.querySelector(`label[for="${checked.id}"]`);
    const v = lab?.getAttribute('sdcustomersalelimit') ?? checked.getAttribute('sdcustomersalelimit');
    const n = v != null ? parseFloat(v) : NaN;
    return isNaN(n) ? null : n;
  }
  return null;
}
function setPdpQtyMaxAndState(sectionId, allowed) {
  // Main form (has the id)
  const mainForm = document.getElementById(`product-form-${sectionId}`);
  // Sticky form (no id; lives under product-add-to-cart-sticky)
  const stickyForm = document.querySelector(
    `product-add-to-cart-sticky[data-section="${sectionId}"] .product-form`
  );
  const applyToForm = (pf) => {
    if (!pf) return;
    const qtySelector = pf.querySelector('quantity-selector');
    const addBtn = pf.querySelector('.single-add-to-cart-button');
    if (allowed <= 0) {
      if (qtySelector) {
        qtySelector.dataset.hiddenByLimit = '1';
        qtySelector.style.display = 'none';
        // also disable the input to be safe
        const qtyInput = qtySelector.querySelector('input[name="quantity"]');
        if (qtyInput) qtyInput.setAttribute('disabled', 'disabled');
      }
      if (addBtn) {
        addBtn.setAttribute('disabled', 'disabled');
        addBtn.classList.add('sold-out');
        const text = addBtn.querySelector('.single-add-to-cart-button--text');
        if (text) text.textContent = 'Limit reached';
      }
      return;
    }
    if (qtySelector) {
      // if previously hidden, show it again
      if (qtySelector.dataset.hiddenByLimit === '1') {
        qtySelector.style.display = '';
        delete qtySelector.dataset.hiddenByLimit;
      }
      const qtyInput = qtySelector.querySelector('input[name="quantity"]');
      if (qtyInput) {
        qtyInput.removeAttribute('disabled');
        // if allowed is Infinity, remove max; otherwise set it
        if (allowed === Number.POSITIVE_INFINITY) {
          qtyInput.removeAttribute('max');
        } else {
          qtyInput.setAttribute('max', String(allowed));
          console.log("allowed "+allowed);
          const current = parseFloat(qtyInput.value || '1');
          if (current > allowed) qtyInput.value = String(allowed);
        }
      }
    }
    if (addBtn) {
      // don’t override genuine hard sold-out
      if (addBtn.dataset.hardSoldout === '1' || addBtn.classList.contains('hard-soldout')) return;

      addBtn.removeAttribute('disabled');
      addBtn.classList.remove('sold-out');

      // re-apply the correct label (Add to cart / Pre-order / Sold Out)
      if (typeof applyButtonStateForSection === 'function') {
        applyButtonStateForSection(sectionId);
      }
    }
  };
  applyToForm(mainForm);
  applyToForm(stickyForm);
}
async function refreshPdpLimitAgainstCartForSection(sectionId) {
  try {
    const limit = getSaleLimitFromActiveAttrsBySection(sectionId);
    if (!limit || limit <= 0) {
      setPdpQtyMaxAndState(sectionId, Number.POSITIVE_INFINITY);
      return;
    }
    const variantId = getCurrentVariantIdFromSection(sectionId);
    if (!variantId) return;
    const existing = await getCartQtyForVariant(variantId);
    const allowed = Math.max(0, limit - existing);
    setPdpQtyMaxAndState(sectionId, allowed);
  } catch (e) {
    console.warn('refreshPdpLimitAgainstCartForSection failed', e);
  }
}
// Add / update hidden "Preorder Group" line item property on forms for a section
function updatePreorderGroupPropertyForSection(sectionId, value) {
  const forms = [];
  // Main product form
  const mainForm = document.getElementById(`product-form-${sectionId}`);
  if (mainForm) forms.push(mainForm);
  // Sticky add-to-cart form (if present)
  const stickyForm = document.querySelector(
    `product-add-to-cart-sticky[data-section="${sectionId}"] .product-form form, 
     product-add-to-cart-sticky[data-section="${sectionId}"] form`
  );
  if (stickyForm) forms.push(stickyForm);
  forms.forEach((form) => {
    if (!form) return;
    // Remove any existing Preorder Group input so we don't duplicate
    form
      .querySelectorAll('input[name="properties[Preorder Group]"]')
      .forEach((el) => el.remove());
    // Only add if we actually have a label (e.g. "Week 14 2026")
    if (value && value.length) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Preorder Group]';
      input.value = value;
      form.appendChild(input);
    }
  });
}

// Add or remove the release-date property on main and sticky product forms.
function updateReleaseDatePropertyForSection(sectionId, value) {
  const forms = [
    document.getElementById(`product-form-${sectionId}`),
    document.querySelector(`product-add-to-cart-sticky[data-section="${sectionId}"] form`)
  ];
  forms.forEach((form) => {
    if (!form) return;
    form.querySelectorAll('input[name="properties[Release Date]"]').forEach((el) => el.remove());
    if (value) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Release Date]';
      input.value = value;
      form.appendChild(input);
    }
  });
}

// Wishlist drawer customisation (SoundDrop) Start

function updateWishlistDrawerToViewProductLinks() {
  try {
    // Remove "Add all to cart" button (if present)
    document
      .querySelectorAll('.nm-wishlist-summery .nm-wishlist-summery-add-all-to-cart')
      .forEach((el) => el.remove());

    const cards = document.querySelectorAll('.nm-wishlist-drawer .nm-wishlist-item-card');
    cards.forEach((card) => {
      const nameLink = card.querySelector('a.nm-wishlist-item-name');
      const url = nameLink && nameLink.href ? nameLink.href : null;
      if (!url) return;

      // Avoid duplicating if already swapped
      if (card.querySelector('a.wish-list-product')) {
        // Still remove any lingering ATC buttons if they re-rendered
        card.querySelectorAll('.nm-wishlist-item-add-to-cart-button').forEach((el) => el.remove());
        return;
      }

      // Find ANY element with this class (not just <button>)
      const addBtns = card.querySelectorAll('.nm-wishlist-item-add-to-cart-button');

      // Build the replacement link
      const viewLink = document.createElement('a');
      viewLink.href = url;
      viewLink.className = 'wish-list-product';
      viewLink.textContent = 'View Product';

      if (addBtns.length) {
        // Insert link where the first ATC button was, then remove all ATC buttons
        addBtns[0].insertAdjacentElement('beforebegin', viewLink);
        addBtns.forEach((el) => el.remove());
      } else {
        // If we can’t find the button, still add the link somewhere sensible
        card.appendChild(viewLink);
      }
    });
  } catch (e) {
    console.warn('updateWishlistDrawerToViewProductLinks failed', e);
  }
}

function watchWishlistDrawerForChanges() {
  const drawer = document.querySelector('.nm-wishlist-drawer');
  if (!drawer || drawer.__sdObserverAttached) return;

  drawer.__sdObserverAttached = true;

  const obs = new MutationObserver(() => {
    updateWishlistDrawerToViewProductLinks();
  });

  obs.observe(drawer, { childList: true, subtree: true });
}

// Remove wishlist open list button after 2 seconds on page load
window.addEventListener('load', function () {
  setTimeout(function () {
    updateWishlistDrawerToViewProductLinks();
  }, 2000);
});

// Wishlist drawer customisation (SoundDrop) End

// SoundDrop Customisation End
if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}